import React from 'react';
import { connect } from 'react-redux';
import { SpringGrid } from 'react-stonecutter';

import './index.css';
import { toggleVacancyModal } from '../../actions';
import VacancyModal from '../../components/vacancyModal';
import VacanciePreview from '../../components/vacancyPreview';
import vacanciesList from './vacancies.json';
import designerMiddle from '../../images/vacancies/ux-ui-designer.jpg';
import designerSenior from '../../images/vacancies/ux-ui-designer-senior.jpg';
import designerJunior from '../../images/vacancies/ux-ui-designer-junior.jpg';
import manager from '../../images/vacancies/it-manager.jpg';

const vacanciesImages = [manager, designerMiddle, designerSenior, designerJunior];
const currentVacancies = vacanciesList.map((vacancy, index) => Object.assign({}, vacancy, { image: vacanciesImages[index] }))

class Vacancies extends React.Component {
  filters = React.createRef();
  state = {
    currentFilter: 'all',
    originalX: 0,
    moveX: 0
  }

  handleFilterChange = (filter) => {
    this.setState({ currentFilter: filter });
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    let cw = nextProps.clientWidth;
    if (cw <= 415) {
      return {
        columns: 1,
        columnWidth: 400,
        gutterWidth: 20,
        itemHeight: 380
      }
    }
    else if (cw <= 868) {
      return {
        columns: 1,
        columnWidth: 600,
        gutterWidth: 20,
        itemHeight: 470
      }
    }
    else if (cw <= 1200) {
      return {
        columns: 2,
        columnWidth: 400,
        gutterWidth: 15,
        itemHeight: 380
      }
    }
    else if (cw <= 1400) {
      return {
        columns: 2,
        columnWidth: 480,
        gutterWidth: 34,
        itemHeight: 410
      }
    } else {
      return {
        columns: 2,
        columnWidth: 581,
        gutterWidth: 40,
        itemHeight: 440
      }
    }
  }

  getFilteredVacancies = (filter) => {
    return filter === 'all' ? currentVacancies : currentVacancies.filter(vacancy => vacancy.filter === filter);
  }

  handleOpenVacancyModal = () => {
    this.props.toggleVacancyModal(true)
  }

  handleScroll = () => {
    let scroll = window.pageYOffset || document.documentElement.scrollTop;
    const filters = this.filters.current;
    if (window.innerWidth >= 1201) {
      if (scroll >= 580) {
        filters.classList.add('vacancies__header__filters-fixed');
      }
      else if (scroll <= 581) {
        filters.classList.remove("vacancies__header__filters-fixed");
      }
    }
    else if (window.innerWidth >= 1001 && window.innerWidth <= 1200) {
      if (scroll >= 380) {
        filters.classList.add('vacancies__header__filters-fixed');
      }
      else if (scroll <= 381) {
        filters.classList.remove("vacancies__header__filters-fixed");
      }
    }
    else if (window.innerWidth <= 1000 && window.innerWidth >= 541) {
      if (scroll >= 320) {
        filters.classList.add('vacancies__header__filters-fixed');

      }
      else if (scroll <= 321) {
        filters.classList.remove("vacancies__header__filters-fixed");
      }
    }

    else if (window.innerWidth <= 540 && window.innerWidth >= 415) {
      if (scroll >= 380) {
        filters.classList.add('vacancies__header__filters-fixed');
      }
      else if (scroll <= 381) {
        filters.classList.remove("vacancies__header__filters-fixed");
      }
    }
    else if (window.innerWidth <= 414) {
      if (scroll >= 285) {
        filters.classList.add('vacancies__header__filters-fixed');
      }
      else if (scroll <= 286) {
        filters.classList.remove("vacancies__header__filters-fixed");
      }
    }
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
  }


  render() {
    return (
      <div className="vacancies page">
        <VacancyModal />
        <div className="vacancies__header">
          <h1>{localStorage.getItem('lang') == 'ru'? 'Вакансии':'vacancies'}</h1>
          <span className="subtitle">
          {localStorage.getItem('lang') == 'ru'? 'Если хочешь участвовать в сложных проектах, взаимодействовать в большой дружной команде – присоединяйcя к нам!':
          'If you want to participate in complex projects, interact in a large friendly team - join us!'} </span>
          <div className="vacancies__header__filters__wrapper" ref={this.filters}>
            <div className="vacancies__header__filters__scroller">
              <div className="vacancies__header__filters">
                <span
                  onClick={() => this.handleFilterChange("all")}
                  className={["vacancies__header__filter",
                    this.state.currentFilter === "all" ? "vacancies__header__filter-active" : ""].join(" ")}>
                  {localStorage.getItem('lang') == 'ru'? 'Все вакансии':'All vacancies'}
            </span>
                <span
                  onClick={() => this.handleFilterChange("designer")}
                  className={["vacancies__header__filter",
                    this.state.currentFilter === "designer" ? "vacancies__header__filter-active" : ""].join(" ")}>
                  {localStorage.getItem('lang') == 'ru'? 'Дизайн':'Design'}
            </span>
                <span
                  onClick={() => this.handleFilterChange("manager")}
                  className={["vacancies__header__filter",
                    this.state.currentFilter === "manager" ? "vacancies__header__filter-active" : ""].join(" ")}>
                  {localStorage.getItem('lang') == 'ru'? 'Менеджмент':'Management'}
            </span>
              </div>
            </div>
          </div>
        </div>
        <div className="vacancies__body">
          <h2 className="vacancies__title">{localStorage.getItem('lang') == 'ru'? 'Стань частью команды Leo':'Become a part of the Leo Team'}</h2>
          <p className="vacancies__description">
          {localStorage.getItem('lang') == 'ru'? 'Тебя ждет полное погружение в сферу, трудные задачи и интересные решения! Не отчаивайся, если ты умеешь не всё что нам нужно. Главное, чтобы ты любил своё дело и горел желанием учиться. Если по какой-то вакансии твой уровень существенно превышает требования или ты не нашел подходящую вакансию, но хочешь работать у нас, напиши краткое письмо о себе на ':
          'You are waiting for a complete immersion in the field, difficult tasks and interesting solutions! Do not despair if you know how not everything we need. The main thing is that you love your job and be eager to learn. If for any vacancy your level significantly exceeds the requirements or you have not found a suitable vacancy, but want to work with us, write a short letter about yourself at '}
             <span className="vacancies__description__email">pm@leotrado.com</span>{localStorage.getItem('lang') == 'ru'? ' и мы что-нибудь придумаем.':' and we’ll come up with something.'}  
          </p>
          <div className="vacancies__list">
            <SpringGrid
              component="ul"
              columns={this.state.columns}
              columnWidth={this.state.columnWidth}
              gutterWidth={this.state.gutterWidth}
              gutterHeight={25}
              itemHeight={this.state.itemHeight}
              springConfig={{ stiffness: 170, damping: 26 }}>
              {this.getFilteredVacancies(this.state.currentFilter).map(vacancy =>
                <div key={vacancy.title} className="vacancy">
                  <VacanciePreview
                    title={vacancy.title}
                    description={vacancy.description}
                    image={vacancy.image}
                    word={vacancy.word}
                    openVacancyModal={() => this.handleOpenVacancyModal()} />
                </div>
              )}
            </SpringGrid>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ clientWidth }) => {
  return {
    clientWidth
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleVacancyModal: (flag) => dispatch(toggleVacancyModal(flag))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Vacancies);



// WEBPACK FOOTER //
// ./src/pages/vacancies/index.jsx